<template>
  <div>
    <router-link to="/speakers">
      <a
        href="#"
        class="relative inline-flex items-center my-2 py-2 text-purple text-sm leading-5 font-medium font-bebas text-3xl
         transition ease-in-out duration-150 border-b-2 border-purple

"
      >
        Back to Speakers
      </a>
    </router-link>
    <div class="bg-vlight-paper rounded-lg mt-2 " v-if="speaker">
      <div class="relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div class="mx-auto text-base max-w-prose lg:max-w-none">
          <p
            class="text-base leading-6 text-green  tracking-wide uppercase font-bebas text-2xl tracking-wider"
          >
            Meet the Speaker
          </p>
          <h1
            class="mt-4 mb-8  font-bebas text-5xl leading-8 font-extrabold tracking-wider text-gray-900 "
          >
            {{ speaker.name }}
          </h1>
        </div>
        <div class="lg:grid lg:grid-cols-2 lg:gap-8">
          <div class="relative mb-8 lg:mb-0 lg:row-start-1 lg:col-start-2">
            <div
              class="relative text-gray-800 mx-auto max-w-prose lg:max-w-none"
            >
              <figure>
                <div class="relative pb-7/12 lg:pb-0">
                  <img
                    :src="portrait"
                    alt=""
                    class="rounded-lg shadow-lg object-cover object-center absolute inset-0 w-full h-full lg:static lg:h-auto"
                  />
                </div>
              </figure>
              <div class="mt-10">
                <h2
                  class=" text-darkpurple font-bebas text-3xl tracking-wider leading-10  sm:leading-none text-center "
                >
                  <span class="border-darkpurple border-b-2">
                    SESSIONS
                  </span>
                </h2>
                <div class="mt-6">
                  <div v-if="groupedSessions[24] != null" class="">
                    <speaker-agenda-item
                      v-for="session in groupedSessions[24]"
                      :key="session._id"
                      :session="session"
                    ></speaker-agenda-item>
                  </div>
                  <div v-if="groupedSessions[25] != null" class="mt-10">
                    <speaker-agenda-item
                      v-for="session in groupedSessions[25]"
                      :key="session._id"
                      :session="session"
                    ></speaker-agenda-item>
                  </div>
                  <div v-if="groupedSessions[26] != null" class="mt-10">
                    <speaker-agenda-item
                      v-for="session in groupedSessions[26]"
                      :key="session._id"
                      :session="session"
                    ></speaker-agenda-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="prose text-gray-900  mx-auto lg:max-w-none lg:row-start-1 lg:col-start-1"
              v-if="speaker.bio"
            >
              <block-content :blocks="speaker.bio" :serializers="serializers">
              </block-content>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sanityClient } from "../utils/sanity";
import sanityImageBuilder from "../utils/sanityImageBuilder";
import BlockContent from "sanity-blocks-vue-component";
import RichTextImage from "../components/RichTextImage";
import RichTextGallery from "../components/RichTextGallery";
import SpeakerAgendaItem from "../components/SpeakerAgendaItem";
export default {
  name: "Speaker",
  components: {
    BlockContent,
    SpeakerAgendaItem
  },
  data() {
    return {
      speaker: null,
      dates: [24, 25, 26],
      groupedSessions: {},
      serializers: {
        types: {
          image: RichTextImage,
          gallery: RichTextGallery
        }
      }
    };
  },
  created() {
    const id = this.$route.params.id;
    const queryString = `*[_type == 'speaker' && _id == $id][0]{...,
    "sessions": *[_type == "session" && references(^._id)] | order(startTime) {
    speakers[]->{...},
      ...
      }
    }`;
    sanityClient
      .fetch(queryString, { id })
      .then(res => {
        this.speaker = res;

        // Group the sessions by date
        const sessions = this.speaker.sessions;
        const groupedSessions = sessions.reduce((groups, session) => {
          const date = new Date(session.startTime).getDate();
          if (!groups[date]) {
            groups[date] = [];
          }
          groups[date].push(session);
          return groups;
        }, {});
        this.groupedSessions = groupedSessions;
      })
      .catch(function(err) {
        console.error(err);
      });
  },
  methods: {},
  computed: {
    portrait() {
      if (this.speaker) {
        return sanityImageBuilder
          .image(this.speaker.portrait)
          .height(400)
          .width(400)
          .url();
      }
      return "";
    }
  }
};
</script>

<style scoped></style>
